import './hazardous-goods.css';
import axios from "axios";
import { useEffect, useState } from "react";
import ViewQuillComponent from '../../../dashboard/admin/textos/viewQuillComponent';

function HazardousGoods() {

  const idComponent = "1c77175f-5556-4d23-8d5c-885fe9196efa";
  const idComponentNoAccepted = "50c1bc14-7da9-4592-a7a8-009b58af3621";
  const [dataInformation, setDataInformation] = useState(() => {
    const newData = {};
    for (let i = 1; i <= 33; i++) {
      newData[`text-${i}`] = "";
    }
    newData["titulo"] = "";
    return {
      "Mercancías de uso común": newData,
    };
  });

  const [dataInformationNoAccepted, setDataInformationNoAccepted] = useState(() => {
    const newData = {};
    for (let i = 1; i <= 33; i++) {
      newData[`text-${i}`] = "";
    }
    newData["titulo"] = "";
    return {
      "Mercancías peligrosas no aceptadas": newData,
    };
  });

  const getTexts = async () => {
    let currentLng = "";
    localStorage.getItem("lng")
      ? (currentLng = `${localStorage.getItem("lng")}`)
      : (currentLng = "es");

    try {
      const response = await axios.get(
        `${process.env.REACT_APP_URL_BACKEND}/api/textWeb/text/${idComponent}`,
        {
          headers: {
            Authorization: process.env.REACT_APP_PUBLIC_KEY,
          },
        }
      );

      console.log(response.data.textWeb.text_es);

      if (currentLng === "es") {
        setDataInformation(
          response.data.textWeb.text_es
        );
      } else {
        setDataInformation(
          response.data.textWeb.text_us
        );
      }
    } catch (error) {
      console.error(error);
    }
  };

  const getTextsNoAccepted = async () => {
    let currentLng = "";
    localStorage.getItem("lng")
      ? (currentLng = `${localStorage.getItem("lng")}`)
      : (currentLng = "es");

    try {
      const response = await axios.get(
        `${process.env.REACT_APP_URL_BACKEND}/api/textWeb/text/${idComponentNoAccepted}`,
        {
          headers: {
            Authorization: process.env.REACT_APP_PUBLIC_KEY,
          },
        }
      );

      if (currentLng === "es") {
        setDataInformationNoAccepted(
          response.data.textWeb.text_es
        );
      } else {
        setDataInformationNoAccepted(
          response.data.textWeb.text_us
        );
      }
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    getTexts();
    getTextsNoAccepted();
  }, []);

  return (
    <>
      <div className="hazardous-container">
        <div className='item-content'>
          <div className='header'>
            {dataInformation && 
              <ViewQuillComponent content={dataInformation?.["01-titulo"]?.content} type={"json"} />
            }
          </div>

          <div className='info-content'>
            {dataInformation &&
              <ViewQuillComponent content={dataInformation?.["02-sub-titulo"]?.content} type={"json"} />
            }

            <br />
            {dataInformation &&
              <ViewQuillComponent content={dataInformation?.["03-texto-ejemplos"]?.content} type={"json"} />
            }

            <div className='items-points'>
              {dataInformation &&
                <ViewQuillComponent content={dataInformation?.["04-puntos-1"]?.content} type={"json"} />
              }

              {dataInformation &&
                <ViewQuillComponent content={dataInformation?.["05-puntos-2"]?.content} type={"json"} />
              }
            </div>
          </div>
        </div>

        <div className='item-content'>
          <div className='header'>
            {dataInformationNoAccepted && 
              <ViewQuillComponent content={dataInformationNoAccepted?.["01-titulo"]?.content} type={"json"} />
            }
          </div>

          <div className='info-content'>
            {dataInformationNoAccepted &&
              <ViewQuillComponent content={dataInformationNoAccepted?.["02-sub-titulo"]?.content} type={"json"} />
            }

            <br />

            <div className='items-points'>
              {dataInformationNoAccepted &&
                <ViewQuillComponent content={dataInformationNoAccepted?.["04-puntos-1"]?.content} type={"json"} />
              }

              {dataInformationNoAccepted &&
                <ViewQuillComponent content={dataInformationNoAccepted?.["05-puntos-2"]?.content} type={"json"} />
              }
            </div>

            <div className='download-infomated-format'>
              <p>Descarga nuestro folleto informativo</p>

              <button className='quote-btn'>COTIZAR</button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default HazardousGoods;
